












import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component
export default class BridgeDisclaimerMobile extends MixinScreenSize {
  @Prop({type: String, required: false}) text!: string
  @Prop({type: String, default: 'text-black'}) textColorClass!: string
}
